var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.195516 6.04015L6.19532 0.190476C6.32041 0.0685167 6.49007 0 6.66697 0C6.84388 0 7.01353 0.0685167 7.13862 0.190476C7.26371 0.312436 7.33399 0.477849 7.33399 0.650326C7.33399 0.822803 7.26371 0.988215 7.13862 1.11018L2.27628 5.85004H15.3334C15.5102 5.85004 15.6797 5.91851 15.8047 6.04041C15.9298 6.1623 16 6.32762 16 6.5C16 6.67238 15.9298 6.8377 15.8047 6.95959C15.6797 7.08149 15.5102 7.14996 15.3334 7.14996H2.27628L7.13862 11.8898C7.26371 12.0118 7.33399 12.1772 7.33399 12.3497C7.33399 12.5222 7.26371 12.6876 7.13862 12.8095C7.01353 12.9315 6.84388 13 6.66697 13C6.49007 13 6.32041 12.9315 6.19532 12.8095L0.195516 6.95985C0.133533 6.89949 0.084362 6.8278 0.0508137 6.7489C0.0172653 6.66999 0 6.58542 0 6.5C0 6.41459 0.0172653 6.33001 0.0508137 6.2511C0.084362 6.1722 0.133533 6.10052 0.195516 6.04015Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.e44d5963957217418ad53281bf268f8d.svg";
export { ForwardRef as ReactComponent };